export const HANDOVERLISTENGINEERING_LOADING = "HANDOVERLISTENGINEERING_LOADING";
export const HANDOVERLISTENGINEERING_RESET = "HANDOVERLISTENGINEERING_RESET";
export const GET_HANDOVERLISTENGINEERING = "GET_HANDOVERLISTENGINEERING";
export const GET_HANDOVERLISTENGINEERING_SUCCESS = "GET_HANDOVERLISTENGINEERING_SUCCESS";
export const GET_HANDOVERLISTENGINEERING_FAIL = "GET_HANDOVERLISTENGINEERING_FAIL";
export const DELETE_HANDOVERLISTENGINEERING = "DELETE_HANDOVERLISTENGINEERING"
export const DELETE_HANDOVERLISTENGINEERING_SUCCESS = "DELETE_HANDOVERLISTENGINEERING_SUCCESS"
export const DELETE_HANDOVERLISTENGINEERING_FAIL = "DELETE_HANDOVERLISTENGINEERING_FAIL"
export const UPDATE_HANDOVERLISTENGINEERING = "UPDATE_HANDOVERLISTENGINEERING"
export const UPDATE_HANDOVERLISTENGINEERING_SUCCESS = "UPDATE_HANDOVERLISTENGINEERING_SUCCESS"
export const UPDATE_HANDOVERLISTENGINEERING_FAIL = "UPDATE_HANDOVERLISTENGINEERING_FAIL"
export const ADD_NEW_HANDOVERLISTENGINEERING = "ADD_NEW_HANDOVERLISTENGINEERING"
export const ADD_HANDOVERLISTENGINEERING_SUCCESS = "ADD_HANDOVERLISTENGINEERING_SUCCESS"
export const ADD_HANDOVERLISTENGINEERING_FAIL = "ADD_HANDOVERLISTENGINEERING_FAIL"